import {Icon} from '@hm/fundamental'
import {mdiDownload} from '@mdi/js'

import type {AttachedDocumentFile} from '../../types'

interface DownloadDocumentOverlayProps {
  attachedDocumentFile: AttachedDocumentFile
}

export const DownloadDocumentOverlay: React.FC<DownloadDocumentOverlayProps> = ({
  attachedDocumentFile
}) => {
  return (
    <a
      href={attachedDocumentFile.preview}
      download={attachedDocumentFile.name}
      className="absolute inset-0 bg-black/40 opacity-0 hover:opacity-100 flex items-center justify-center transition-opacity duration-200"
      data-cy="attached_document_download_overlay"
    >
      <Icon
        path={mdiDownload}
        color="black"
        size="xlarge"
        data-cy="attached_document_download_button"
      />
    </a>
  )
}
